module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.676b36b7.svg";